export const loadMessages = (locale) => import(`./${locale}.json`);
export { messages } from './messages';
